import React, { useState, useEffect } from 'react';

export default function App() {
  // Загрузка активной вкладки из localStorage или установка по умолчанию
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('activeTab') || 'home';
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  // Объект с номерами телефонов для каждой локации
  const phoneNumbers = {
    krasnodar_rashpil: '+7 (903) 449-22-02',
    krasnodar_rashpil_vip: '+7 (918) 186-45-30',
    krasnodar_atarbek: '+7 (961) 598-71-30',
    krasnodar_40let: '+7 (961) 528-35-26',
    apsheronsk: '+7 (918) 005-25-27'
  };

  // Сохранение активной вкладки в localStorage при её изменении
  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  const openImageModal = (src) => {
    setModalImage(src);
  };

  const closeImageModal = () => {
    setModalImage(null);
  };

  // Функция для обработки навигации
  const handleNavigation = (tab) => {
    setActiveTab(tab);
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0); // Прокрутка вверх при переходе
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen font-sans">
      {/* Header */}
      <header className="relative z-10 bg-gray-900">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div 
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => handleNavigation('home')}
          >
            <span className="text-2xl font-extrabold bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 text-transparent bg-clip-text">
              WellPlayed
            </span>
            <span className="text-xs uppercase tracking-wider text-gray-400">Клубы</span>
          </div>
          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 text-sm uppercase tracking-wider">
            {['home','locations','features','booking'].map(tab => (
              <button
                key={tab}
                onClick={() => handleNavigation(tab)}
                className={`transition-all ${
                  activeTab === tab
                    ? 'text-blue-400'
                    : 'text-gray-300 hover:text-blue-400'
                }`}
              >
                {{
                  home:      'Главная',
                  locations: 'Локации',
                  features:  'Особенности',
                  booking:   'Бронирование'
                }[tab]}
              </button>
            ))}
          </div>
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-300 focus:outline-none"
            aria-label="Toggle menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </nav>
        {/* Mobile Menu */}
				{isMobileMenuOpen && (
		  <div className="md:hidden bg-gray-800/90 backdrop-blur-md px-6 py-4 border-t border-gray-700">
			<ul className="space-y-4 text-sm uppercase tracking-wider">
			  {['home','locations','features','booking'].map((tab) => (
				<li key={tab}>
				  <button
					onClick={() => handleNavigation(tab)}
					className={`w-full text-left transition ${activeTab === tab ? 'text-blue-400' : 'text-gray-300 hover:text-blue-400'}`}
				  >
					{{ home: 'Главная', locations: 'Локации', features: 'Особенности', booking: 'Бронирование' }[tab]}
				  </button>
				</li>
			  ))}
			</ul>
		  </div>
		)}
      </header>

      {/* Hero Section */}
      {activeTab === 'home' && (
        <section className="relative overflow-hidden">
          {/* Градиент и фон */}
          <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-blue-900/20 opacity-30"></div>
          <div className="absolute inset-0">
            <div className="w-full h-full bg-[url('https://picsum.photos/1920/1080 ')] bg-cover bg-center opacity-10"></div>
          </div>
          {/* Контент */}
          <div className="container mx-auto px-6 py-20 relative z-10">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-5xl md:text-6xl font-extrabold mb-6 leading-tight">
                <span className="block bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 text-transparent bg-clip-text">
                  Добро пожаловать в будущее
                </span>
                <span className="block mt-2 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 text-transparent bg-clip-text whitespace-nowrap">
                  гейминга
                </span>
              </h1>
              <p className="text-lg md:text-xl text-gray-400 mb-10">
                Испытайте гейминг нового поколения на мощных ПК и консолях PlayStation 5 во всех клубах WellPlayed.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <button
                  onClick={() => handleNavigation('booking')}
                  className="px-8 py-3 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 transition-all transform hover:-translate-y-1"
                >
                  Забронировать
                </button>
                <button 
                  onClick={() => handleNavigation('locations')}
                  className="px-8 py-3 rounded-full border border-blue-500 text-blue-400 hover:bg-blue-500/10 transition-all"
                >
                  Посмотреть локации
                </button>
              </div>
            </div>
            {/* Блок с изображениями */}
            <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
              {['1.webp', '2.webp', '3.webp', '4.webp', '5.webp', '6.webp', '7.webp', '8.webp'].map((img, idx) => (
                <div 
                  key={idx} 
                  className="overflow-hidden rounded-xl shadow-lg group cursor-pointer"
                  onClick={() => openImageModal(`/images/${img}`)}
                >
                  <img 
                    src={`/images/${img}`} 
                    alt={`Изображение ${idx + 1}`}
                    className="w-full h-40 object-cover transform transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
              ))}
            </div>
          </div>
          {/* Нижний градиент */}
          <div className="absolute -bottom-20 left-0 right-0 h-40 bg-gradient-to-t from-gray-900 to-transparent z-20"></div>
        </section>
      )}

      {/* Features Section */}
      {activeTab === 'features' && (
        <section className="py-20 bg-gray-900">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Игровые технологии нового уровня
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Все клубы WellPlayed оснащены передовыми технологиями для идеального игрового опыта.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              {/* Card 1 */}
              <div className="group relative p-8 rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-blue-500/50 transition-all duration-300">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-600/10 opacity-0 group-hover:opacity-10 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-16 h-16 mb-6 rounded-xl bg-blue-500/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-400" fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Мощные ПК</h3>
                  <p className="text-gray-400 mb-4">
                    Наши игровые станции оснащены последними процессорами, видеокартами NVIDIA RTX и сверхбыстрыми SSD.
                  </p>
                  <div className="pt-4 border-t border-gray-700">
                    <ul className="space-y-2 text-sm text-gray-500">
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> Процессоры i5
                      </li>
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> RTX 4060ti
                      </li>
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> 32 ГБ RAM
                      </li>
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> SSD NVME
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Card 2 */}
              <div className="group relative p-8 rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-purple-500/50 transition-all duration-300">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-600/10 opacity-0 group-hover:opacity-10 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-16 h-16 mb-6 rounded-xl bg-purple-500/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-purple-400" fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-3">PlayStation 5</h3>
                  <p className="text-gray-400 mb-4">
                    Молниеносная загрузка, 4K, трассировка лучей и Tempest 3D AudioTech.
                  </p>
                  <div className="pt-4 border-t border-gray-700">
                    <ul className="space-y-2 text-sm text-gray-500">
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> 4K Blu-ray
                      </li>
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> DualSense
                      </li>
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> Tempest Audio
                      </li>
                      <li className="flex items-center">
                        <span className="mr-2 text-green-500">•</span> SSD 825 ГБ
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Card 3 */}
              <div className="group relative p-8 rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-pink-500/50 transition-all duration-300">
                <div className="absolute inset-0 bg-gradient-to-r from-pink-500/10 to-red-600/10 opacity-0 group-hover:opacity-10 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-16 h-16 mb-6 rounded-xl bg-pink-500/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-pink-400" fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Премиум комфорт</h3>
                  <p className="text-gray-400 mb-4">
                    Эргономичные кресла, звукоизоляция, RGB-подсветка и мониторы 165-390 Гц.
                  </p>
                  <div className="pt-4 border-t border-gray-700">
                    <ul className="space-y-2 text-sm text-gray-500">
                      <li className="flex items-center"><span className="mr-2 text-green-500">•</span> RGB</li>
                      <li className="flex items-center"><span className="mr-2 text-green-500">•</span> Наушники</li>
                      <li className="flex items-center"><span className="mr-2 text-green-500">•</span> Механика</li>
                      <li className="flex items-center"><span className="mr-2 text-green-500">•</span> 165-390 Гц</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Locations Section */}
      {activeTab === 'locations' && (
        <section className="py-20 bg-gray-900">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Найдите ближайший клуб</h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Мы предлагаем современные игровые площадки в Краснодаре и крае.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Location Card 1 */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-blue-500/50 transition-all duration-300">
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img
                    src="/images/rash1.webp"
                    alt="Клуб Краснодар Рашпилевская VIP Premium"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. Рашпилевская, д. 130/1</p>
                  <ul className="text-sm text-gray-500 space-y-2">
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span>
                      <span>40 игровых станций</span>
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span>
                      <span>2 PS5 бокса</span>
                    </li>
                    <li className="flex items-center">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 mr-2 text-blue-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 
                               2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 
                               20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 
                               0V3h3V1.5m-3 0h3m-3 18.75h3"
                          />
                        </svg>
                      <a href="tel:+79034492202" className="hover:text-blue-400 transition font-bold">
                        +7 (903) 449-22-02
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Location Card 1 VIP Premium */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-blue-500/50 transition-all duration-300">
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img
                    src="/images/rashp.jpg"
                    alt="Клуб Краснодар Рашпилевская"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. Рашпилевская, д. 130/1 VIP Premium</p>
                  <ul className="text-sm text-gray-500 space-y-2">
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span>
                      <span>10 игровых станций</span>
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span>
                      <span>0 PS5 боксов</span>
                    </li>
                    <li className="flex items-center">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 mr-2 text-blue-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 
                               2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 
                               20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 
                               0V3h3V1.5m-3 0h3m-3 18.75h3"
                          />
                        </svg>
                      <a href="tel:+79181864530" className="hover:text-blue-400 transition font-bold">
                        +7 (918) 186-45-30
                      </a>
                      <span className="ml-1 text-pink-500 text-xs">(VIP Premium)</span>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Location Card 2 */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-blue-500/50 transition-all duration-300">
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img src="/images/atarbek.jpg" alt="Клуб Краснодар ул. Атарбекова" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. Атарбекова, д. 45</p>
                  <ul className="text-sm text-gray-500 space-y-2">
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span>
                      <span>30 игровых станций</span>
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span>
                      <span>2 PS5 бокса</span>
                    </li>
                    <li className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5 mr-2 text-blue-400">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                      </svg>
                      <a href="tel:+79615987130" className="hover:text-blue-400 transition font-bold">
                        +7 (961) 598-71-30
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Location Card 3 — Краснодар, ул. 40-летия Победы, 144/4а */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-purple-500/50 transition-all duration-300">
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img src="/images/40let.jpg" alt="Клуб Краснодар ул. 40-летия Победы" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. 40-летия Победы, д. 144/4а</p>
                  <ul className="text-sm text-gray-500 space-y-2">
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span> 30 игровых станций
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span> 2 PS5 бокса
                    </li>
                    <li className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5 mr-2 text-blue-400">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                      </svg>
                      <a href="tel:+79615283526" className="hover:text-blue-400 transition font-bold">
                        +7 (961) 528-35-26
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Location Card 4 — Апшеронск, ул. Гагарина, д. 3 */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/50 backdrop-blur-md border border-gray-700 hover:border-pink-500/50 transition-all duration-300">
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img src="/images/apsh.jpg" alt="Клуб Апшеронск" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">Апшеронск</h3>
                  <p className="text-gray-400 mb-4">ул. Гагарина, д. 3</p>
                  <ul className="text-sm text-gray-500 space-y-2">
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span> 20 игровых станций
                    </li>
                    <li className="flex items-center">
                      <span className="mr-2 text-green-500">•</span> 5 PS5 боксов
                    </li>
                    <li className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5 mr-2 text-blue-400">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                      </svg>
                      <a href="tel:+79180052527" className="hover:text-blue-400 transition font-bold">
                        +7 (918) 005-25-27
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Booking Section */}
      {activeTab === 'booking' && (
        <section className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 py-20">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">
                Выберите локацию для бронирования
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto text-lg">
                Нажмите на любую локацию ниже, чтобы связаться с администратором и забронировать время.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {/* Краснодар Рашпилевская */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/70 backdrop-blur-md border border-gray-700 hover:border-blue-500/50 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-xl hover:shadow-blue-500/10 cursor-pointer"
                   onClick={() => window.location.href='tel:+79034492202'}>
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img
                    src="/images/rash1.webp"
                    alt="Клуб Краснодар Рашпилевская"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity"></div>
                </div>
                <div className="p-6 relative">
                  <div className="absolute top-4 right-4 bg-blue-500/20 text-blue-400 rounded-full p-2 backdrop-blur-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. Рашпилевская, д. 130/1</p>
                  <div className="flex items-center text-blue-400 font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    +7 (903) 449-22-02
                  </div>
                </div>
              </div>

              {/* Краснодар Рашпилевская VIP Premium */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/70 backdrop-blur-md border border-gray-700 hover:border-purple-500/50 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-xl hover:shadow-purple-500/10 cursor-pointer"
                   onClick={() => window.location.href='tel:+79181864530'}>
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img
                    src="/images/rashp.jpg"
                    alt="Клуб Краснодар Рашпилевская VIP Premium"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity"></div>
                </div>
                <div className="p-6 relative">
                  <div className="absolute top-4 right-4 bg-purple-500/20 text-purple-400 rounded-full p-2 backdrop-blur-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. Рашпилевская, д. 130/1 VIP Premium</p>
                  <div className="flex items-center text-purple-400 font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    +7 (918) 186-45-30
                  </div>
                </div>
              </div>

              {/* Краснодар Атарбекова */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/70 backdrop-blur-md border border-gray-700 hover:border-blue-500/50 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-xl hover:shadow-blue-500/10 cursor-pointer"
                   onClick={() => window.location.href='tel:+79615987130'}>
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img
                    src="/images/atarbek.jpg"
                    alt="Клуб Краснодар ул. Атарбекова"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity"></div>
                </div>
                <div className="p-6 relative">
                  <div className="absolute top-4 right-4 bg-blue-500/20 text-blue-400 rounded-full p-2 backdrop-blur-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. Атарбекова, д. 45</p>
                  <div className="flex items-center text-blue-400 font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    +7 (961) 598-71-30
                  </div>
                </div>
              </div>

              {/* Краснодар 40-летия Победы */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/70 backdrop-blur-md border border-gray-700 hover:border-purple-500/50 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-xl hover:shadow-purple-500/10 cursor-pointer"
                   onClick={() => window.location.href='tel:+79615283526'}>
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img
                    src="/images/40let.jpg"
                    alt="Клуб Краснодар ул. 40-летия Победы"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity"></div>
                </div>
                <div className="p-6 relative">
                  <div className="absolute top-4 right-4 bg-purple-500/20 text-purple-400 rounded-full p-2 backdrop-blur-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Краснодар</h3>
                  <p className="text-gray-400 mb-4">ул. 40-летия Победы, д. 144/4а</p>
                  <div className="flex items-center text-purple-400 font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    +7 (961) 528-35-26
                  </div>
                </div>
              </div>

              {/* Апшеронск */}
              <div className="group relative overflow-hidden rounded-2xl bg-gray-800/70 backdrop-blur-md border border-gray-700 hover:border-pink-500/50 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-xl hover:shadow-pink-500/10 cursor-pointer"
                   onClick={() => window.location.href='tel:+79180052527'}>
                <div className="aspect-video bg-gray-700 overflow-hidden">
                  <img
                    src="/images/apsh.jpg"
                    alt="Клуб Апшеронск"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity"></div>
                </div>
                <div className="p-6 relative">
                  <div className="absolute top-4 right-4 bg-pink-500/20 text-pink-400 rounded-full p-2 backdrop-blur-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Апшеронск</h3>
                  <p className="text-gray-400 mb-4">ул. Гагарина, д. 3</p>
                  <div className="flex items-center text-pink-400 font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    +7 (918) 005-25-27
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-16 text-center">
              <p className="text-gray-400 italic">Все звонки осуществляются напрямую на номера администраторов локаций</p>
            </div>
          </div>
        </section>
      )}

			 {/* Footer */}
		<footer className="py-12 bg-gray-800/50 border-t border-gray-700">
		  <div className="container mx-auto px-6">
			<div className="grid grid-cols-1 md:grid-cols-4 gap-8">
			  <div>
				<h3 className="text-xl font-bold mb-4">WellPlayed</h3>
				<p className="text-gray-400 text-sm">
				  Будущее гейминга уже здесь. Присоединяйтесь к WellPlayed и испытайте новый уровень развлечений.
				</p>
			  </div>
			  <div>
				<h3 className="text-lg font-semibold mb-4">Ссылки</h3>
				<ul className="space-y-2 text-gray-400 text-sm">
				  {[
					{ tab: 'home', label: 'Главная' },
					{ tab: 'locations', label: 'Локации' },
					{ tab: 'features', label: 'Особенности' },
					{ tab: 'booking', label: 'Бронирование' }
				  ].map(({ tab, label }) => (
					<li key={tab}>
					  <button 
						onClick={() => handleNavigation(tab)}
						className="hover:text-blue-400 transition cursor-pointer"
					  >
						{label}
					  </button>
					</li>
				  ))}
				</ul>
			  </div>
			  <div>
				<h3 className="text-lg font-semibold mb-4">Правовая информация</h3>
				<ul className="space-y-2 text-gray-400 text-sm">
				  <li><a href="/privacy-policy.html" className="hover:text-blue-400 transition">Политика конфиденциальности</a></li>
				  <li><a href="/terms-of-use.html" className="hover:text-blue-400 transition">Условия использования</a></li>
				  <li><a href="/cookies-policy.html" className="hover:text-blue-400 transition">Политика cookies</a></li>
				</ul>
			  </div>
			  <div>
				<h3 className="text-lg font-semibold mb-4">Контакты</h3>
				<address className="not-italic text-gray-400 text-sm space-y-2">
				  <p>Email: <a href="mailto:contact@wellplayed.ru" className="hover:text-blue-400">info@wpgaming.ru</a></p>
				  <p>Соцсети: <a href="https://vk.com/wp_krd " target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">@wellplayed_krd</a></p>
				</address>

				{/* Новая строка для связи по созданию сайтов */}
				<p className="mt-4 text-gray-400 text-sm">
				  По вопросам создания сайтов{' '}
				  <a href="https://t.me/coin_voin " target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">
					обращайтесь
				  </a>
				</p>
			  </div>
			</div>


			<div className="mt-12 pt-6 border-t border-gray-700 text-center text-gray-500 text-sm">
			  <p>&copy; {new Date().getFullYear()} WellPlayed Clubs. Все права защищены.</p>
			</div>
		  </div>
		</footer>

      {/* Modal для просмотра изображения */}
      {modalImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={closeImageModal}
        >
          <div 
            className="relative max-w-4xl w-full bg-gray-900 rounded-xl shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="absolute top-4 right-4 bg-black/50 hover:bg-black text-white p-2 rounded-full z-10"
              onClick={closeImageModal}
              aria-label="Закрыть"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={modalImage} 
              alt="Увеличенное изображение" 
              className="w-full h-auto"
            />
          </div>
        </div>
      )}
    </div>
  );
}